import { render, staticRenderFns } from "./SubscriptionAdvertising.vue?vue&type=template&id=2182a1de&scoped=true"
import script from "./SubscriptionAdvertising.vue?vue&type=script&lang=js"
export * from "./SubscriptionAdvertising.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionAdvertising.vue?vue&type=style&index=0&id=2182a1de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182a1de",
  null
  
)

export default component.exports